export type Language = "ar" | "en";

export const translations = {
  en: {
    hotline: "Hotline",
    phoneNumber: "01228 251 328",
    email: "support@nowpay.cash",
    address: "12 Nile Street – Giza",
    contacts: "Contacts",
    home: "Home",
    faq: "FAQ",
    careers: "Careers",
    inTheNews: "In The News",
    inTheNewsDesc: "Stay updated with the latest news and media coverage about NowPay",
    contactUs: "Contact Us",
    downloadApp: "Download the App",
    heroTitle: "Secure your team’s financial wellbeing",
    heroDesc: "Financial stress costs companies billions of dollars in lost productivity, affecting team performance and wellbeing. NowPay gives your team the power to get paid easily, pay their bills, and deal with the unexpected at any time.",
    bookDemo: "Learn more",
    whatsInIt: "What's in it for you?",
    companies: "Companies",
    teams: "Teams",
    boostWellbeing: "Boost wellbeing, productivity, loyalty",
    endHassle: "End the corporate hassle",
    zeroLiability: "Enjoy zero liability.",
    plugPlay: "Plug and play. No technical integrations",
    sharia: "Full Compliance with Sharia",
    companiesBenefit1: "Improved employee happiness, productivity and corporate loyalty",
    companiesBenefits2: "Remove the hassle of handling corporate loans",
    companiesBenefits3: "Free for corporations. Zero liability. No change in employer cash flow, we front the money",
    companiesBenefits4: "Seamless integration with your current systems",
    reduceStress: "Reduce financial stress. Access your pay anytime you want. We've got you covered",
    customerSupport: "Get customer support every day of the week",
    secureTransactions: "Secure your electronic transactions",
    teamsBenefits1: "Gain discounts and perks from your favorite stores",
    teamsBenefits2: "Pay your bills instantly without the need for credit/debit cards",
    cashFree: "Enjoy living the cash-free experience",
    topShoppingNetwork: "Top Shopping Network",
    buyNow: "Buy now from your favorite stores",
    nowpayEffect: "The NowPay Effect",
    companiesCount: "300+",
    companiesDesc: "companies providing our solutions to their teams",
    paymentsCount: "1.5B+",
    paymentsDesc: "of monthly payments managed by NowPay",
    peopleCount: "350K+",
    peopleDesc: "people benefiting from NowPay's financial wellbeing solutions",
    endorsements: "Endorsements",
    testimonialText:
      "NowPay was the easiest salary advance service I ever dealt with - it also guarantees complete privacy since the employee requests the money directly through the app and no third party is involved",
    testimonialName: "Viezh Robert",
    testimonialLocation: "Warsaw, Poland",
    partnerSteps: "Becoming a Partner in 5 Simple Steps",
    step1: "Sign up to NowPay",
    step2: "Ask your team to register on the NowPay App",
    step3: "Team members ask for the services at any time",
    step4: "NowPay provides the services",
    step5: "Company repays NowPay",
    downloadTitle: "Download the NowPay App",
    downloadDesc:
      "NowPay mobile app is available on the Apple and Google stores.",
    downloadCta: "Start your financial wellbeing journey. Get the app now!",
    chooseTheStore: "Choose your app store",
    backToHome: "Back to Home Page",
    getInTouch: "Get in touch",
    contactDetails: "Please leave your contact details and we will reach out to you.",
    send: "Send",
    formName: "Name",
    formEmail: "Email Address",
    formPhoneNumber: "Phone Number",
    formCompanyName: "Company Name",
    companySize: "Company Size",
    formMessage: "Message",
    submitLoading: "Sending...",
    submitSuccess: "Message sent successfully. We'll get back to you soon.",
    submitError: "Something went wrong. Please try again.",
    ourClients: "Our Clients",
    aboutUs: "About Us",
    privacyPolicy: "Privacy Policy",
    termsConditions: "Terms & Conditions",
    allRightsReserved: " © NowPay's. All Rights Reserved. No part of this site may be reproduced without permission.",
    regulatedBy: "Regulated by the Saudi Central Bank",
    salaryAdvance: "Salary Advance",
    cancel: "Cancel",
    payBackOver: "pay back over 5 month",
    youWillPay: "you will pay",
    sarMonthly: "SAR 525 monthly",
    startingFrom: "(approximately) starting May,2022",
    sign: "Sign",
    paymentDetails: "Payment details",
    includingFees: "Including Fees",
    BenefitsSectionTitle: "How we boost your team’s financial wellbeing",

    BenefitsSectionFeatures: [
      {
        id: 1,
        title: "All-time Salary Access",
        description:
          "NowPay gives your team access to their salaries.",
        image: "salary-access.svg",
      },
      {
        id: 2,
        title: "Invest in Gold and Silver",
        description:
          "NowPay enables your team to easily and securely invest in gold and silver directly through the app.",
        image: "gold-investment.svg",
      },
      {
        id: 3,
        title: "Instant Bill Payments",
        description:
          "NowPay enables your team to pay all their bills instantly through our app without having to enter any credit or debit card details.",
        image: "bill-payments.svg",
      },
      {
        id: 4,
        title: "Shopping Plans",
        description:
          "NowPay makes it possible for your team to shop from our network of top stores.",
        image: "shopping-installments.svg",
      },
      {
        id: 5,
        title: "Money Transfers",
        description:
          "NowPay facilitates cash-free money transfers between users through the app.",
        image: "money-transfers.svg",
      },
    ],
    endorsementsData: [
      {
        name: "Hossam Nasr Askar",
        jobTitle: "Head of Hr Operations",
        description:
          "NowPay was the easiest salary advance service I ever dealt with - it also guarantees complete privacy since the employee requests the money directly through the app and no third party is involved",
      },
      {
        name: "Sarah Abaza",
        jobTitle: "HR Manager of Canal Sugar",
        description:
          "“We are glad to partner with NowPay to help enhance the financial-wellness of our employees. NowPay’s team has been diligent and focused on providing a great experience from the initial partnership conversations all the way to the actual deployment of the service. We are very happy we established such a partnership.”",
      },
      {
        name: "Noura Mohamed",
        jobTitle: "Talent acquisition manager at Americana",
        description: "“When we listened to our colleagues, we learned that this was the sort of benefit they really wanted”"
      },
      {
        name: "Yasmine Daoud",
        jobTitle: "Talent Business Partner at KraftHeinz",
        description: "“Instant Salary Advances facility by NowPay has been great for our employees, giving them the flexibility to take control of their finances, reducing stress, and enhancing their financial wellbeing”"
      },
      {
        name: "Tarek El Maghraby",
        jobTitle: "HR Manager at Mazaya",
        description: "“Partnering with NowPay has had a positive impact on our employees' retention and financial resilience”"
      },
      {
        name: "Ramy Adel Zayed",
        jobTitle: "HR & Administration Director at Beltone Financial",
        description: "“A great benefit to improve employee financial fitness and mental wellbeing”"
      },
    ],
    Awards:"Awards & Recognition",
    awardsDesc: "Proudly awarded by trusted industry leaders",
    faqTitle: "Frequently Asked Questions",
    faqLoading: "Loading...",
    faqLoadError: "Failed to load FAQs. Please try again.",
    faqFetchFailed: "Failed to load FAQs",
    faqEmpty: "No FAQs available.",
    faqRetry: "Retry",
    clientCategories: [
      "All",
      "Multinationals",
      "Listed",
      "Government",
      "Industrial",
      "Manufacturing & Healthcare",
      "Aviation",
      "Large Real Estate",
      "Retail",
      "Investments",
      "Other",
    ],
    aboutNowpay: 'About Nowpay',
    aboutNowpayDesc: 'NowPay is a fintech startup building a financial-wellness platform for employees in emerging markets. We enable the workforce to better manage their budgets, and we are backed by Endure and 500 Startups.',
    servicesPricing: 'Services Pricing ',
    servicesPricingDesc: 'All services offered through the NowPay application have a clearly stated price before the purchase is completed.',
    deliveryShipmentPolicy: 'Delivery / Shipment Policy',
    deliveryShipmentPolicyDesc: [
      'NowPay offers online services as well as offline shopping services.',
      'NowPay services are delivered within a maximum of 48 hours. Any other services involving third parties depend on each third party’s individual time frame.',
      'NowPay does not provide services or products to countries sanctioned by the Office of Foreign Assets Control (OFAC).'
    ],
    refundPolicy: 'Cancellation & Refund Policy',
    refundPolicyDesc: [
      'Unless otherwise specified, purchases from NowPay are non-returnable after they are completed. Once paid, services offered by NowPay cannot be canceled or replaced.',
      'In the event of service cancellation due to technical issues or unavailability from the service provider, a refund will be issued within 30 days.',
      'If you experience any problems with a purchased service, please report the issue within 14 days of the purchase date so we can investigate it accordingly.',
    ],
    noRefundPolicy: 'No Refund Policy',
    noRefundPolicyDesc: [
      'Since our mobile application offers non-tangible, irrevocable goods, we do not provide refunds after a product is purchased. You acknowledge this prior to making any purchase. Please ensure you have carefully read the service description before completing your purchase.',
      'If a transaction error occurs during payment, a refund will, in most cases, be issued to the same credit card used for the original purchase.',
      'Refunds will only be issued through the original method of payment.',
    ],
    refundConditions: 'Conditions Under Which Refunds Will Be Provided',
    refundConditionsDesc: [
      'The service provider failed to complete the service.',
      'A technical problem occurred during the purchase.',
    ],
    privacyPolicyDesc: 'Your privacy is critically important to us.\nNowpay is located at:\n12 Nile st, Above Al-Yaman Cultural Center, Giza.\nIt is Nowpay’s policy to respect your privacy regarding any information we may collect while operating our website and application. This Privacy Policy applies to www.nowpay.com (hereinafter “us,” “we,” or “Nowpay”).\nWe are committed to protecting personally-identifiable information you may provide us through the Website or application. This Privacy Policy explains what information may be collected on our website/application, how we use this information, and under what circumstances we may disclose it to third parties. This Privacy Policy applies only to information collected through the Website/application and does not cover information obtained from other sources.\nThis Privacy Policy, together with the Terms and Conditions posted on our website/application, sets forth the general rules and policies governing your use of our website/application. Depending on your activities when visiting our website/application, you may be required to agree to additional terms and conditions.',
    dataCollectionAndSecurity: 'Data Collection and Security',
    dataCollectionAndSecurityDesc: [
      'iOS/Android App collects the following data – it is not shared with any third party:',
      'Location: Approximate location, Precise location',
      'Personal info: Name, Email address, User IDs, Address, Phone number',
      'Financial info: User payment info, Other financial info (e.g., salary, debts)',
      'Photos and videos: Photos',
      'Contacts: Contacts',
      'App activity: App interactions, In-app search history, Other actions',
      'App info and performance: Crash logs, Other app performance data',
      'Device or other IDs: Device ID',
    ],
    websiteVisitors: 'Website/Application Visitors',
    websiteVisitorsDesc: 'Like most website/application operators, Nowpay collects non-personally identifying information such as browser type, language preference, referring site, and the date and time of each visitor request. The purpose is to better understand how visitors use our website/application. From time to time, we may release aggregated, non-personally-identifying information (e.g., reports on trends in website/application usage).\nWe also collect potentially personally-identifying information like IP addresses for logged-in users or commenters on NowPay blog posts. We disclose IP addresses only under the same circumstances as other personally-identifying information.',
    idGathering: 'Gathering of Personally-Identifying Information',
    idGatheringDesc: 'Certain visitors may choose to interact with Nowpay in ways that require us to gather personally-identifying information. The amount and type of information gathered depends on the nature of the interaction. For example, visitors signing up for a blog at NowPay are asked to provide a username and email address.',
    security : 'Security',
    securityDesc: 'Nowpay follows high security standards; however, no method of transmission over the Internet or electronic storage is 100% secure. While we use commercially acceptable means to protect your Personal Information, we cannot guarantee absolute security.',
    advertisements : 'Advertisements',
    advertisementsDesc: 'Ads appearing on our website/application may be delivered by advertising partners, who may set cookies. These cookies allow ad servers to recognize your computer, compile information, and deliver targeted advertisements. This Privacy Policy covers the use of cookies by Nowpay and does not cover the use of cookies by advertisers.',
    externalLinks: 'Links to External Sites',
    externalLinksDesc: 'Our service may contain links to external sites not operated by us. Clicking a third-party link will direct you to that site. We strongly advise reviewing the Privacy Policy and terms of every site you visit. We have no control over, and assume no responsibility for, the content, privacy policies, or practices of any third-party sites.',
    infoProtection: 'Protection of Personally Identifying Information',
    infoProtectionDesc: 'Nowpay discloses personally-identifying information only to employees, contractors, and affiliated organizations who need it to process it on our behalf or provide services, and who have agreed not to disclose it to others. Some of these individuals may be located outside your home country; by using our website/application, you consent to the transfer of your information.\nNowpay will not rent, sell, or lease personally-identifying information to anyone. We may disclose information in response to subpoenas, court orders, governmental requests, or when reasonably necessary to protect the rights or property of Nowpay, third parties, or the public.\nIf you are a registered user of NowPay and have provided your email address, we may occasionally send emails regarding new features, feedback, or updates. Requests submitted via support channels may be published to clarify responses or support other users.',
    aggregatedStatistics: 'Aggregated Statistics',
    aggregatedStatisticsDesc: 'Nowpay may collect statistics about visitor behavior, which may be displayed publicly or shared with others. We do not disclose personally-identifying information.',
    cookies: 'Cookies',
    cookiesDesc: 'Nowpay uses cookies and similar technologies to display personalized content, deliver appropriate advertising, and store preferences. Cookies are strings of information stored on a visitor’s computer and provided to the website/application upon return visits.\nVisitors who do not wish to have cookies placed on their computers should set their browsers to refuse cookies. However, some website/application features may not function properly without cookies. By continuing to use our website/application without changing cookie settings, you acknowledge and agree to Nowpay’s use of cookies.',
    eCommerce: 'E-Commerce',
    eCommerceDesc: 'Visitors engaging in transactions with Nowpay (e.g., purchasing services or products) may provide additional personal and financial information required to process the transaction. We collect this information only as necessary to fulfill the purpose of the interaction.\nPersonally-identifying information will not be disclosed except as described above. Visitors can refuse to supply information, but this may limit certain activities on the website/application.',
    businessTransfers: 'Business Transfers',
    businessTransfersDesc: 'If Nowpay or substantially all its assets are acquired, or in the event of bankruptcy, user information may be transferred to a third party. Any acquirer may continue to use your personal information as set forth in this policy.',
    privacyPolicyChanges: 'Privacy Policy Changes',
    privacyPolicyChangesDesc: 'Nowpay may change this Privacy Policy from time to time. We encourage visitors to review this page frequently for updates. Continued use of the site after any changes constitutes acceptance of the updated policy.',
    additionalNotes: 'Additional Notes',
    additionalNotesDesc: [
      'All credit/debit card details and personally-identifiable information will not be stored, sold, shared, rented, or leased to third parties.',
      'Some advertisements are delivered by third parties (ad networks, agencies, advertisers). These third parties may collect information about you through cookies or other technologies. We do not control these practices; their information collection is not covered by this Privacy Policy.',
    ],
    termsAndConditions: 'Terms & Conditions',
    introduction: '1. Introduction',
    introductionDesc: 'NowPay (“we”, “our”, or “the Company”) provides financial services through its mobile application in Egypt. By accessing or using the NowPay application and services (“NowPay Services”), you agree to be bound by these Terms and Conditions. If you do not agree, you must not use the app.',
    services: 'NowPay Services include:',
    servicesDesc: [
      'Salary Advance',
      'Bill Payments',
      'Shopping',
      'Investing',
    ],
    supportInfo: 'Support contact information:',
    supportInfoDesc: [
      'Email: [Support@nowpay.com]',
      'Phone: [01228251328]',
    ],
    definitions: '2. Definitions',
    definitionsDesc: [
      {bold: 'NowPay Services:', description: 'All services provided through the NowPay application, including financial transactions and related features.'},
      {bold: 'Transaction:', description: 'Any action performed through the app, including salary advance requests, bill payments, shopping purchases, or investments.'},
      {bold: 'Service Fee:', description: 'Any fee charged by NowPay for providing a service, including applicable taxes.'},
      {bold: 'User Account:', description: 'The account created by the user to access NowPay Services.'},
    ],
    eligibilityAndAgreement: '3. Eligibility and Agreement ',
    eligibilityAndAgreementDesc: [
      'By registering for and using NowPay Services, you confirm that:',
      'You have read and understood these Terms and Conditions.', 
      'You are legally eligible to use financial services in Egypt.', 
      'All information provided is accurate and complete.', 
      'You agree to comply with all applicable laws and regulations.',
      'NowPay reserves the right to refuse or suspend services if eligibility requirements are not met.'
    ],
    accountRegistration: '4. Account Registration',
    accountRegistrationDesc: [
      'To use NowPay Services, you must create an account in the application./nYou are responsible for:', 
      'Maintaining the confidentiality of your login credentials.', 
      'Ensuring all account information remains accurate.', 
      'Notifying NowPay immediately of any unauthorized access.', 
    ],
    transactions: '5. Transactions',
    transactionsDesc: [
      'All Transactions are subject to approval according to NowPay policies.', 
      'Approved Transactions will be executed as shown in the application.', 
      'Rejected Transactions may be reviewed by contacting customer support.', 
    ],
    support: 'Support:',
    dataPrivacyAndSecurity: '6. Data, Privacy, and Security',
    dataPrivacyAndSecurityDesc: [
      'NowPay collects and processes personal and financial data to provide services, prevent fraud, and comply with Egyptian laws. By using the app, you consent to:', 
      'Data verification and KYC procedures.', 
      'Sharing necessary data with partners such as employers, banks, or payment providers.', 
      'Access to services may be restricted until verification is completed.', 
    ],
    fraud: '7. Unauthorized Use and Fraud',
    fraudDesc: [
      'Users must report any unauthorized account activity immediately.', 
      'NowPay is not responsible for losses caused by delayed reporting.', 
      'Accounts may be suspended or terminated if fraudulent activity is suspected.', 
    ],
    intellectualProperty: '8. Intellectual Property ',
    intellectualPropertyDesc: 'All content, trademarks, and technology within the NowPay application are owned by NowPay. Users may not copy, reproduce, or distribute any part of the application without prior written permission.',
    amendments: '9. Amendments',
    amendmentsDesc: 'NowPay may update these Terms and Conditions at any time. Updated terms become effective once published in the application. Continued use of the app constitutes acceptance of the updated terms.',
    governingLaw: '10. Governing Law and Jurisdiction',
    governingLawDesc: 'These Terms and Conditions are governed by the laws of the Arab Republic of Egypt. Any disputes shall be resolved before the competent Egyptian courts.',
    consent: '11. User Consent',
    consentDesc: 'By using NowPay Services, you acknowledge that you have read, understood, and agreed to these Terms and Conditions and authorized NowPay to process your data as required to provide the services.',
    news: [
      {
        newsDate: "January 22, 2026",
        newsTitle: "Egypt’s NowPay enters Saudi market with $20 million-backed Tas’heel partnership",
        newsDescription: "Egypt-based fintech NowPay is launching in Saudi Arabia through NowAccess, a joint venture with Tas'heel",
        newsLink: "https://www.wamda.com/2026/01/egypt-nowpay-enters-saudi-market-20m-backed-tasheel-partnership",
        newsImage: "/news/news1.webp",
        media: "Wamda",
      },
      {
        newsDate: "January 25, 2026",
        newsTitle: "NowPay Enters Saudi Market With $20M Tas'heel Partnership",
        newsDescription: "Egyptian fintech NowPay launches NowAccess in Saudi Arabia through a $20 million joint venture with Tas'heel",
        newsLink: "https://cairoscene.com/Business/NowPay-Enters-Saudi-Market-With-20M-Tas-heel-Partnership",
        newsImage: "/news/news2.webp",
        media: "Cairo Scene",
      },
      {
        newsDate: "January 23, 2026",
        newsTitle: "NowPay enters Saudi market",
        newsDescription: "Egyptian fintech firm NowPay has entered the Saudi market through the launch of NowAccess, a joint venture with Tas'heel, the consumer finance arm",
        newsLink: "https://www.islamicfinancenews.com/nowpay-enters-saudi-market.html",
        newsImage: "/news/news3.svg",
        media: "Islamic Finance News",
      },
      {
        newsDate: "January 22, 2026",
        newsTitle: "NowPay Secures $20 Million to Expand into Saudi Arabia",
        newsDescription: "The fintech will launch its payroll and financial wellness platform through a new joint venture",
        newsLink: "https://www.startupresearcher.com/news/nowpay-secures-usd20-million-to-expand-into-saudi-arabia",
        newsImage: "/news/news4.svg",
        media: "Startup Researcher",
      },
      {
        newsDate: "January 22, 2026",
        newsTitle: "Egypt-based Fintech NowPay Raises $20M to Expand Shariah Compliance Payroll...",
        newsDescription: "Instead of navigating Saudi regulation alone, NowPay is taking the faster route—launching through a $20M-backed joint venture with Tas'heel",
        newsLink: "https://arabfounders.net/en/nowpay-enters-saudi-arabia-nowaccess-tasheel-20m-jv/",
        newsImage: "/news/news5.webp",
        media: "Arab Founders",
      },
      {
        newsDate: "January 24, 2026",
        newsTitle: "Egyptian Fintech NowPay Raises $20M to Take Its Payroll and Earned Wage Access...",
        newsDescription: "NowPay continues its regional expansion as it enters the Saudi market through a joint venture with Tas'heel",
        newsLink: "https://techbuild.africa/egyptian-fintech-nowpay-20m-payroll-earned-wage/",
        newsImage: "/news/news6.svg",
        media: "TechBuild Africa",
      },
      {
        newsDate: "June 19, 2025",
        newsTitle: "Tasheel and NowPay launch 'Now Access' to digitize wage processing in Saudi Arabia",
        newsDescription: "Tasheel and NowPay announce the launch of Now Access to digitize wage processing in Saudi Arabia",
        newsLink: "https://wasssl.com/tasheel-and-nowpay-launch-now-access-to-digitize-wage-processing-in-saudi-arabia/",
        newsImage: "/news/news7.webp",
        media: "Wasssl",
      },
      {
        newsDate: "January 22, 2026",
        newsTitle: "Egypt's NowPay Lands $20m to Launch Saudi Joint Venture",
        newsDescription: "Egypt's NowPay secures $20 million to launch its joint venture in Saudi Arabia",
        newsLink: "https://launchbaseafrica.com/2026/01/22/egypts-nowpay-lands-20m-to-launch-saudi-joint-venture/",
        newsImage: "/news/news8.svg",
        media: "LaunchBase Africa",
      }
    ],
    readArticle: "Read Article",
    visitSaudiSite: "Saudi Website",
    formConsent: "I have read and understood the Service Consent Form, and I consent to the collection, use, and disclosure of my personal data as described in it."

  },
  ar: {
    hotline: "الخط الساخن",
    phoneNumber: "01228 251 328",
    email: "support@nowpay.com",
    address: "١٢ شارع النيل - الجيزة",
    contacts: "تواصل معنا",
    home: "الرئيسية",
    faq: "اسئلة مكررة",
    careers: "الوظائف",
    inTheNews: "في الأخبار",
    inTheNewsDesc: "تابع آخر الأخبار والتغطيات الصحفية عن ناوباي في وسائل الإعلام",
    contactUs: "تواصل معنا",
    downloadApp: " قم بتنزيل التطبيق",
    heroTitle: "وفّر لفريقك الأمان المالي",
    heroDesc: "تكلّف الضغوط المالية الشركات خسائر تصل إلى مليارات الدولارات لما لها من تأثير سلبي على الإنتاجية، وأداء فريق العمل. تتيح ناوباي لفريقك الحصول على رواتبهم مقدماً، بالإضافة إلى سداد فواتيرهم، وتلبية احتياجاتهم المالية الطارئة في أي وقت.",
    bookDemo: "تعرف على المزيد",
    whatsInIt: "ما الذي سيعود عليك؟",
    companies: "الشركات",
    teams: "فريق العمل",
    boostWellbeing: "تعزيز الرفاهية والإنتاجية والولاء",
    endHassle: "إنهاء المتاعب الإدارية",
    zeroLiability: "استمتع بعدم تحمل أي مسؤولية",
    plugPlay: "سهل الاستخدام. بدون تكاملات تقنية",
    sharia: "متوافق تماماً مع الشريعة الإسلامية",
    companiesBenefit1: "تعزيز الأمان المالي لفريقك وزيادة الإنتاجية والولاء",
    companiesBenefits2: "التخلص من متاعب القروض للشركات",
    companiesBenefits3: "استمتع بخدماتنا مجانًا وبدون أي مدفوعات مسبقة، فنحن نتكفل بالنفقات مقدماً!",
    companiesBenefits4: "لا تعقيدات تقنية، كل ما عليك  هو تحميل التطبيق وتسجيل الدخول",
    reduceStress: "تخفيف الضغوط المالية. نوفر لكم إمكانية الوصول إلى رواتبكم متى شئتم، حتى تتمكنوا من تلبية احتياجاتكم المالية في أي وقت",
    customerSupport: "خدمة العملاء على مدار الأسبوع",
    secureTransactions: "معاملات إلكترونية سلسة وآمنة",
    teamsBenefits1: "خصومات وامتيازات من متاجركم المفضلة",
    teamsBenefits2: "سداد الفواتير على الفور دون الحاجة إلى بطاقات الائتمان/الخصم.",
    cashFree: "تجربة غير نقدية",
    topShoppingNetwork: "تسوّق من أفضل المتاجر",
    buyNow: 'احصل على مشترياتك من متاجرك المفضلة، وادفع لاحقاً على أقساط تخصم من الراتب، في مدة تصل إلى 10 أشهر.',
    nowpayEffect: "حقائق وأرقام ناوباى",
    companiesCount: "+300",
    companiesDesc: "عدد الشركات التي نقدم حلولنا لفرقهم",
    paymentsCount: "+1.5B",
    paymentsDesc: "من الدفعات الشهرية تدار بواسطة ناو باي",
    peopleCount: "+350K",
    peopleDesc: "من الأشخاص الذين يستفيدون من حلول الامان المالي التى تقدمها ناو باى",
    endorsements: "شهادات عملائنا",
    testimonialText:
      "ناو باي كانت أسهل خدمة سلفة راتب تعاملت معها على الإطلاق - كما أنها تضمن الخصوصية الكاملة حيث يطلب الموظف المال مباشرة من خلال التطبيق ولا يوجد طرف ثالث متورط",
    testimonialName: "فيزه روبرت",
    testimonialLocation: "وارسو، بولندا",
    partnerSteps: "انضم إلينا في 5 خطوات بسيطة",
    step1: "اشترك في ناوباي",
    step2: "اطلب من فريقك التسجيل في تطبيق ناوباي",
    step3:"يمكن لأعضاء فريقك طلب رواتبهم مقدماً في أي وقت",
    step4: "توفر ناوباي الأموال مقدماً",
    step5: "تقوم الشركة بخصم الدفعات المقدمة من الرواتب مستقبلاً، وتسددها لـ ناوباي",
    downloadTitle: "قم بتنزيل تطبيق ناوباي",
    downloadDesc: "تطبيق الجوال من ناوباي متاح على جوجل بلاي وآبل.",
    downloadCta: "قم بتنزيل التطبيق الآن، واستمتع بالأمان المالي!",
    chooseTheStore: "اختر متجر التطبيقات الخاص بك",
    backToHome: "العودة إلى الصفحة الرئيسية",
    getInTouch: "تواصل معنا",
    contactDetails: "يرجى ترك بيانات التواصل الخاصة بك وسنقوم بالتواصل معك.",
    send: "إرسال",
    formName: "الاسم",
    formEmail: "البريد الإلكتروني",
    formPhoneNumber: "رقم الهاتف",
    formCompanyName: "اسم الشركة",
    companySize: "عدد موظفين الشركة",
    formMessage: "الرسالة",
    submitLoading: "جاري الإرسال...",
    submitSuccess: "تم إرسال رسالتك بنجاح. سنتواصل معك قريباً.",
    submitError: "حدث خطأ. يرجى المحاولة مرة أخرى.",
    ourClients: "عملائنا",
    aboutUs: "معلومات عنا",
    privacyPolicy: "سياسة الخصوصية",
    termsConditions: "البنود و الظروف",
    allRightsReserved: "© ناوباي. كل الحقوق محفوظة. لا يجوز إعادة إنتاج أي جزء من هذا الموقع دون إذن.",
    regulatedBy: "مرخصة من البنك المركزي السعودي",
    salaryAdvance: "سلفة الراتب",
    cancel: "إلغاء",
    payBackOver: "السداد على 5 أشهر",
    youWillPay: "ستدفع",
    sarMonthly: "525 ريال شهرياً",
    startingFrom: "(تقريباً) بدءاً من مايو 2022",
    sign: "توقيع",
    paymentDetails: "تفاصيل الدفع",
    includingFees: "شامل الرسوم",
    BenefitsSectionTitle: "كيف نعزز الأمان المالي لفريقك",
    BenefitsSectionFeatures: [
      {
        id: 1,
        title: "حرية الحصول على الراتب في أي وقت",
        description:
          "تمنح ناوباي فريقك الحصول على رواتبهم متى احتاجوا إليها، و تقسيطها على فترة سداد مرنة.",
        image: "salary-access.svg",
      },
      {
        id: 2,
        title: "الاستثمار في الذهب والفضة",
        description:
          "يُمكّن فريقك من الاستثمار بسهولة وأمان في الذهب والفضة مباشرة عبر التطبيق.",
        image: "gold-investment.svg",
      },

      {
        id: 3,
        title: "سداد فوري للفواتير",
        description:
          "توفر ناوباي لفريقك القدرة على سداد جميع فواتيرهم على الفور من خلال تطبيقنا دون الحاجة إلى إدخال بيانات بطاقة الائتمان أو الخصم.",
        image: "bill-payments.svg",
      },
      {
        id: 4,
        title: "سداد فواتير التسوق بمرونة",
        description:
          "تتيح ناوباي لفريقك التسوق من شبكتنا التي تضم أفضل المتاجر، مع خطة سداد مرنة على أقساط تصل إلى 10 أشهر.",
        image: "shopping-installments.svg",
      },
      {
        id: 5,
        title: "تحويل الأموال بين موظفي شركتك",
        description:
          "تسهل ناوباي تحويل الأموال بين أعضاء فريقك عبر التطبيق.",
        image: "money-transfers.svg",
      },
    ],
    endorsementsData: [
      {
        name: "حسام نصر عسكر",
        jobTitle: "رئيس عمليات الموارد البشرية ",
        description :"”ناوباي هي أسهل خدمة للحصول على الرواتب مقدماً تعاملت معها على الإطلاق - كما أنها تضمن الخصوصية الكاملة للموظفين حيث أن المستخدم يطلب المبلغ مباشرةً من خلال التطبيق بسرية تامة“ "
      },
      {
        name: "سارة أباظة",
        jobTitle: "مدير الموارد البشرية",
        description:
          "”نحن سعداء بالتعاون مع ناوباي لتعزيز رفاهية الموظفين المالية. كان فريق ناوباي مجتهدًا ومركزاً على توفير تجربة رائعة من محادثات الشراكة الأولية حتى تنفيذ الخدمة الفعلي. نحن سعداء جدًا لتأسيس مثل هذه الشراكة“",
      },
      {
        name:"نوره محمد",
        jobTitle: "مدير اكتساب المواهب",
        description: "”عندما استمعنا إلى موظفينا، وجدنا أن خدمة الراتب مقدماً من أهم الخدمات التي ستشكل فارق كبير في راحتهم واستقرارهم“"
      },
      {
        name: "ياسمين داود",
        jobTitle: "شريك اكتساب المواهب",
        description: "“خدمة الراتب مقدما الفورية المقدمة من من ناوباي أثرت بشكل إيجابي كبير على موظفينا ، حيث منحتهم المرونة للسيطرة على مواردهم المالية ، والحد من التوتر ، وتحسين رفاهيتهم بشكل عام”"
      },
      {
        name: "طارق المغربي",
        jobTitle: "مدير الموارد البشرية",
        description: "“الشراكة مع ناوباي كان لها تأثير إيجابي كبير على احتفاظنا بموظفينا وتحسين استقرارهم المالي وقدرتهم على إدارة حياتهم المالية بكل راحة”"
      },
      {
        name: "رامي عادل زايد",
        jobTitle: "مدير الموارد البشرية والشؤون الإدارية",
        description: "“خدمة مفيدة جدا لتحسين الاستقرار المالي للموظفين وراحتهم النفسية”"
      },
    ],
    Awards:"الجوائز والتقديرات",
    awardsDesc: "حصلنا على تقدير أبرز الجهات الموثوقة في المجال",
    faqTitle: "الأسئلة الشائعة",
    faqLoading: "جارٍ التحميل...",
    faqLoadError: "تعذر تحميل الأسئلة الشائعة. حاول مرة أخرى.",
    faqFetchFailed: "فشل تحميل الأسئلة الشائعة",
    faqEmpty: "لا توجد أسئلة متاحة.",
    faqRetry: "إعادة المحاولة",
    clientCategories: [
      "الكل",
      "شركات عالمية",
      "شركات مدرجة",
      "جهات حكومية",
      "قطاع صناعي",
      "التصنيع والرعاية الصحية",
      "قطاع الطيران",
      "العقارات الكبرى",
      "قطاع التجزئة",
      "قطاع الاستثمارات",
      "أخرى",
    ],
    aboutNowpay: 'عن ناوباي',
    aboutNowpayDesc: 'ناوباي هي شركة ناشئة في مجال التكنولوجيا المالية تقوم ببناء منصة للرفاهية المالية للموظفين في الأسواق الناشئة. نُساعد القوى العاملة على إدارة ميزانياتهم بشكل أفضل، ونحن مدعومون من Endure  و 500 Startups',
    servicesPricing: 'سعر الخدمات',
    servicesPricingDesc: 'جميع الخدمات المقدمة عبر تطبيق ناوباي تحتوي على سعر واضح قبل إتمام عملية الشراء.',
    deliveryShipmentPolicy: 'سياسة التسليم / الشحن',
    deliveryShipmentPolicyDesc: [
      'تقدم ناوباي خدمات عبر الإنترنت وخدمات تسوق غير متصلة بالإنترنت',
      'يتم تسليم خدمات ناوباي في غضون حد أقصى ٤٨ ساعة. أي خدمات أخرى تتضمن طرفًا ثالثًا تعتمد على الإطار الزمني الخاص بكل طرف ثالث.',
      'لا تقدم ناوباي خدمات أو منتجات إلى أي دول خاضعة لعقوبات مكتب مراقبة الأصول الأجنبية (OFAC).'
    ],
    refundPolicy: 'سياسة الإلغاء والاسترداد',
    refundPolicyDesc: [
      'ما لم ينص على خلاف ذلك، فإن المشتريات من ناوباي غير قابلة للإعادة بعد إتمامها. بمجرد الدفع، لا يمكن إلغاء الخدمات أو استبدالها.',
      'ي حال إلغاء الخدمة بسبب مشاكل تقنية أو عدم توفرها من مزود الخدمة، سيتم إصدار استرداد مالي خلال ٣٠ يومًا.',
      'إذا واجهت أي مشكلة في خدمة تم شراؤها، يرجى الإبلاغ عن المشكلة خلال ١٤ يومًا من تاريخ الشراء حتى نتمكن من التحقيق',
    ],
    noRefundPolicy: 'سياسة عدم الاسترداد ',
    noRefundPolicyDesc: [
      'نظرًا لأن تطبيقنا يقدم سلعًا غير ملموسة ولا يمكن الرجوع فيها، لا يتم تقديم استرداد مالي بعد شراء المنتج. أنت تقر بذلك قبل إجراء أي عملية شراء. يرجى التأكد من قراءة وصف الخدمة بعناية قبل إتمام الشراء.',
      'إذا حدث خطأ في المعاملة أثناء الدفع، فسيتم في معظم الحالات إصدار استرداد لنفس بطاقة الائتمان المستخدمة في الشراء الأصلي.',
      'سيتم إصدار الاسترداد فقط عبر طريقة الدفع الأصلية.',
    ],
    refundConditions: 'الأحوال التي يتم فيها تقديم الاسترداد',
    refundConditionsDesc: [
      'لم يقُم مزود الخدمة بإكمال الخدمة.',
      'حدثت مشكلة تقنية أثناء الشراء.',
    ],
    privacyPolicyDesc: 'خصوصيتك مهمة للغاية بالنسبة لنا.\nشركة ناوباي تقع في:\n12 شارع النيل، فوق المركز الثقافي اليمني، الجيزة.\nتلتزم ناوباي بسياسة احترام خصوصيتك فيما يتعلق بأي معلومات قد نقوم بجمعها أثناء تشغيل موقعنا الإلكتروني وتطبيقنا. تنطبق سياسة الخصوصية هذه علي www.nowpay.com (يشار إليها فيما يلي بـ "نحن" أو "لنا" او "ناوباي").\nنحن ملتزمون بحماية المعلومات التي يمكن التعرف على صاحبها شخصيًا والتي قد تقدّمها لنا من خلال الموقع الإلكتروني أو التطبيق. تشرح هذه السياسة المعلومات التي قد يتم جمعها على موقعنا/تطبيقنا، وكيف نستخدم هذه المعلومات، وتحت أي ظروف قد نكشفها لأطراف ثالثة. تنطبق هذه السياسة فقط على المعلومات التي يتم جمعها من خلال الموقع/التطبيق ولا تشمل المعلومات التي تم الحصول عليها من مصادر أخرى.\nتحدد سياسة الخصوصية هذه، إلى جانب الشروط والأحكام المنشورة على موقعنا/تطبيقنا، القواعد العامة والسياسات التي تحكم استخدامك للموقع/التطبيق. اعتمادًا على نشاطك عند زيارة موقعنا/تطبيقنا، قد يُطلب منك الموافقة على شروط وأحكام إضافية.',
    dataCollectionAndSecurity: 'جمع البيانات والأمان\nيقوم تطبيق iOS/Android بجمع البيانات التالية – ولا تتم مشاركتها مع أي طرف ثالث:',
    dataCollectionAndSecurityDesc: [
      'الموقع: الموقع التقريبي، الموقع الدقيق',
      'المعلومات الشخصية: الاسم، عنوان البريد الإلكتروني، معرفات المستخدم، العنوان، رقم الهاتف',
      'المعلومات المالية: معلومات الدفع الخاصة بالمستخدم، معلومات مالية أخرى (مثل: الراتب، الديون)',
      'الصور ومقاطع الفيديو: الصور',
      'جهات الاتصال: جهات الاتصال',
      'نشاط التطبيق: تفاعلات التطبيق، سجل البحث داخل التطبيق، إجراءات أخرى',
      'معلومات التطبيق والأداء: سجلات الأعطال، بيانات أداء التطبيق الأخرى',
      'معرّفات الجهاز أو غيرها: معرّف الجهاز',
    ],
    websiteVisitors: 'زوار الموقع/التطبيق',
    websiteVisitorsDesc: 'مثل معظم مشغّلي المواقع/التطبيقات، يقوم ناوباي بجمع معلومات غير معرفّة بشخصية مثل نوع المتصفح، تفضيل اللغة، الموقع المرجعي، وتاريخ ووقت كل طلب زيارة. الهدف من ذلك هو فهم كيفية استخدام الزوار لموقعنا/تطبيقنا بشكل أفضل. من وقت لآخر، قد نعلن معلومات مجمّعة غير معرفّة بشخصية (مثل: تقارير عن اتجاهات استخدام الموقع/التطبيق).\nكما نقوم أيضًا بجمع معلومات من المحتمل أن تكون معرفّة بشخصية مثل عناوين بروتوكول الإنترنت (IP) للمستخدمين المسجّلين أو المعلقين على منشورات مدونة ناوباي يتم الكشف عن عناوين IP فقط في نفس الظروف التي يتم فيها الكشف عن المعلومات المعرفّة بشخصية أخرى.',
    idGathering: 'جمع المعلومات المعرفّة بشخصية',
    idGatheringDesc: 'قد يختار بعض الزوار التفاعل مع ناوباي بطرق تتطلب منا جمع معلومات يمكن التعرف على صاحبها شخصيًا. كمية ونوع المعلومات التي يتم جمعها يعتمد على طبيعة التفاعل. على سبيل المثال، الزوار الذين يسجّلون للحصول على مدونة في ناوباي يُطلب منهم تقديم اسم مستخدم وعنوان بريد إلكتروني.',
    security : 'الأمان',
    securityDesc: 'تتبع ناوباي معايير أمان عالية؛ ومع ذلك، لا توجد طريقة نقل عبر الإنترنت أو تخزين إلكتروني آمنة بنسبة ١٠٠٪. بينما نستخدم وسائل مقبولة تجاريًا لحماية معلوماتك الشخصية، لا يمكننا ضمان الأمن المطلق.',
    advertisements : 'الإعلانات',
    advertisementsDesc: 'قد تظهر إعلانات على موقعنا/تطبيقنا يتم تقديمها من قِبل شركاء إعلانيين، والذين قد يضعون ملفات تعريف ارتباط (cookies). تتيح هذه الملفات لخوادم الإعلانات التعرف على جهازك، وتجميع المعلومات، وتقديم إعلانات مستهدفة. تغطي سياسة الخصوصية هذه استخدام ملفات تعريف الارتباط من قبل ناوباي  ولا تشمل استخدام ملفات تعريف الارتباط من قبل المعلنين.',
    externalLinks: 'الروابط إلى مواقع خارجية',
    externalLinksDesc: 'قد يحتوي خدماتنا على روابط لمواقع خارجية لا تديرها ناوباي. النقر على رابط طرف ثالث سيحوّلك إلى ذلك الموقع. ننصح بشدة بمراجعة سياسة الخصوصية والشروط والأحكام لكل موقع تزوره. نحن لا نتحكم ولا نتحمل أي مسؤولية عن محتوى أو سياسات الخصوصية أو ممارسات أي من مواقع الطرف الثالث.',
    infoProtection: 'حماية المعلومات المعرفّة بشخصية',
    infoProtectionDesc: 'تقوم ناوباي بالكشف عن المعلومات التي يمكن التعرف على صاحبها شخصيًا فقط للموظفين والمتعاقدين والمنظمات التابعة التي تحتاجها لمعالجتها نيابةً عنا أو تقديم الخدمات، وقد اتفقت هذه الأطراف على عدم كشفها للآخرين. وقد يكون بعض هؤلاء الأفراد موجودين خارج بلدك الأم؛ باستخدامك موقعنا/تطبيقنا، فإنك توافق على نقل معلوماتك.\nلن تقوم ناوباي بتأجير أو بيع أو تأجير معلومات يمكن التعرف على صاحبها شخصيًا لأي شخص. قد نكشف المعلومات استجابةً لأوامر استدعاء، أو أوامر المحكمة، أو طلبات حكومية، أو عند الضرورة المعقولة لحماية حقوق أو ممتلكات ناوباي أو أطراف ثالثة أو الجمهور.\nإذا كنت مستخدمًا مسجّلًا لدى ناوباي وقد قمت بتزويدنا بعنوان بريدك الإلكتروني، فقد نقوم من حين لآخر بإرسال رسائل بريد إلكتروني بخصوص الميزات الجديدة، أو طلب اراء، أو التحديثات. قد يتم نشر الطلبات المقدّمة عبر قنوات الدعم لتوضيح الردود أو دعم مستخدمين آخرين.',
    aggregatedStatistics: 'الإحصاءات المجمّعة',
    aggregatedStatisticsDesc: 'قد يقوم ناوباي بجمع إحصاءات حول سلوك الزوار، والتي قد يتم عرضها علنًا أو مشاركتها مع الآخرين. نحن لا نكشف عن معلومات يمكن التعرف على صاحبها شخصيًا.',
    cookies: 'ملفات تعريف الارتباط (cookies)',
    cookiesDesc: 'يستخدم ناوباي ملفات تعريف الارتباط والتقنيات المماثلة لعرض المحتوى المخصّص، وتقديم الإعلانات المناسبة، وتخزين التفضيلات. ملفات تعريف الارتباط هي سلاسل من المعلومات المخزّنة على جهاز الزائر ويتم تقديمها مرة أخرى للموقع/التطبيق عند الزيارات اللاحقة.\nيجب على الزوار الذين لا يرغبون في أن يتم وضع هذه الملفات على أجهزتهم إعداد متصفحاتهم لرفضها. ومع ذلك، قد لا تعمل بعض ميزات الموقع/التطبيق بشكل صحيح بدونها. باستخدامك الموقع/التطبيق دون تغيير إعدادات هذه الملفات، فإنك تقر وتوافق على استخدام ناوباي لها.',
    eCommerce: 'التجارة الإلكترونية',
    eCommerceDesc: 'الزوار الذين يقومون بمعاملات عبر ناوباي (مثل: شراء خدمات أو منتجات) قد يقدّمون معلومات شخصية ومالية إضافية مطلوبة لمعالجة المعاملة. نحن نجمع هذه المعلومات فقط بالقدر اللازم لتنفيذ الغرض من التفاعل. لن يتم الكشف عن معلومات يمكن التعرف على صاحبها شخصيًا إلا كما هو موضح أعلاه. يمكن للزوار رفض تقديم المعلومات، لكن هذا قد يقيّد بعض الأنشطة على الموقع/التطبيق.',
    businessTransfers: 'انتقال الأعمال',
    businessTransfersDesc: 'إذا تم الاستحواذ على ناوباي أو على معظم أصولها، أو في حالة الإفلاس، قد يتم نقل معلومات المستخدم إلى طرف ثالث. وقد يقوم أي مستحوذ بمواصلة استخدام معلوماتك الشخصية كما هو محدد في هذه السياسة.',
    privacyPolicyChanges: 'تغييرات سياسة الخصوصية',
    privacyPolicyChangesDesc: 'قد تقوم ناوباي بتغيير سياسة الخصوصية هذه من وقت لآخر. نشجّع الزوار على مراجعة هذه الصفحة بشكل متكرر للتحديثات. استمرارك في استخدام الموقع بعد أي تغييرات يعد قبولًا بسياسة الخصوصية المحدثة.',
    additionalNotes: 'ملاحظات إضافية',
    additionalNotesDesc: [
      'لن يتم تخزين أو بيع أو مشاركة أو تأجير معلومات بطاقة الائتمان/الخصم أو المعلومات التي يمكن التعرف على صاحبها شخصيًا لأطراف ثالثة.',
      'بعض الإعلانات يتم تقديمها من قِبل أطراف ثالثة (شبكات إعلانية، وكالات، معلنين). قد تقوم هذه الأطراف بجمع معلومات عنك من خلال ملفات تعريف الارتباط (cookies) أو تقنيات أخرى. نحن لا نتحكم في هذه الممارسات؛ وجمع المعلومات من قِبلهم غير مغطّى بسياسة الخصوصية هذه.',
    ],
    termsAndConditions: 'الشروط والأحكام',
    introduction: '١- المقدمة',
    introductionDesc: 'ناوباي (يشار إليها فيما يلي بـ "نحن" أو "الشركة") تقدم خدمات مالية عبر تطبيق الهاتف المحمول الخاص بها داخل جمهورية مصر العربية. باستخدامك لتطبيق ناوباي أو أي من خدماته ("خدمات ناوباي")، فإنك توافق على الالتزام بهذه الشروط والأحكام. في حال عدم الموافقة، يُرجى عدم استخدام التطبيق.',
    services: 'تشمل خدمات ناوباي:',
    servicesDesc: [
      'السلف المالية', 
      'دفع الفواتير', 
      'التسوق', 
      'الاستثمار', 
    ],
    supportInfo: 'بيانات التواصل والدعم:',
    supportInfoDesc: [
     'البريد الإلكتروني: [Support@nowpay.com]',
     'رقم الهاتف: [٠١٢٢٨٢٥١٣٢٨]', 
    ],
    definitions: '٢- التعاريف',
    definitionsDesc: [
      {bold: 'خدمات ناوباي:', description: 'جميع الخدمات المقدمة عبر تطبيق ناوباي ، بما في ذلك المعاملات المالية والخدمات المرتبطة بها.'},
      {bold: 'المعاملة:', description: 'أي إجراء يتم عبر التطبيق مثل طلب سلفة، دفع فاتورة، عملية شراء أو استثمار.'},
      {bold: 'رسوم الخدمة:', description: 'أي رسوم تفرضها ناوباي مقابل تقديم الخدمات، شاملة الضرائب المطبقة.'},
      {bold: 'حساب المستخدم:', description: 'الحساب الذي ينشئه المستخدم للوصول إلى خدمات ناوباي.'},
    ],
    eligibilityAndAgreement: '٣ -الأهلية والاتفاق',
    eligibilityAndAgreementDesc: [
      'باستخدامك لخدمات ناوباي، فإنك تقر وتوافق على:', 
      'أنك قرأت وفهمت هذه الشروط.', 
      'أنك مؤهل قانونيًا لاستخدام الخدمات المالية في مصر.', 
      'أن جميع البيانات المقدمة صحيحة وكاملة.', 
      'الالتزام بكافة القوانين واللوائح المعمول بها.', 
      'تحتفظ ناوباي بحق رفض أو تعليق الخدمة في حال عدم استيفاء شروط الأهلية.', 
    ],
    accountRegistration: '٤ -تسجيل الحساب',
    accountRegistrationDesc: [
      'لاستخدام خدمات ناوباي، يجب إنشاء حساب داخل التطبيق. ويتحمل المستخدم مسؤولية:', 
      'الحفاظ على سرية بيانات الدخول.', 
      'تحديث البيانات الشخصية بشكل صحيح.', 
      'إخطار ناوباي فورًا في حال الاشتباه بأي استخدام غير مصرح به.', 
    ],
    transactions: '٥ -المعاملات',
    transactionsDesc: [
      'تخضع جميع المعاملات لموافقة ناوباي وفقًا لسياساتها.', 
      'يتم تنفيذ المعاملات المعتمدة كما هو موضح داخل التطبيق.', 
      'يمكن مراجعة المعاملات المرفوضة من خلال التواصل مع الدعم.', 
    ],
    support: 'الدعم:',
    dataPrivacyAndSecurity: '٦- البيانات والخصوصية والأمان',
    dataPrivacyAndSecurityDesc: [
      'تقوم  ناوباي بجمع ومعالجة البيانات الشخصية والمالية لتقديم الخدمات، منع الاحتيال، والامتثال للقوانين المصرية. باستخدامك للتطبيق، فإنك توافق على:', 
      'إجراءات التحقق ومعرفة العميل .(KYC)', 
      'مشاركة البيانات اللازمة مع الشركاء مثل أصحاب العمل أو البنوك أو مزودي الدفع.', 
      'قد يتم تقييد الوصول إلى الخدمات لحين استكمال التحقق..', 
    ],
    fraud: '٧ -الاستخدام غير المصرح به والاحتيال',
    fraudDesc: [
      'يجب الإبلاغ فورًا عن أي استخدام غير مصرح به للحساب.', 
      'لا تتحمل ناوباي مسؤولية أي خسائر ناتجة عن التأخر في الإبلاغ.', 
      'يحق لـناوباي تعليق أو إنهاء الحساب في حال الاشتباه في نشاط احتيالي.', 
    ],
    intellectualProperty: '٨- الملكية الفكرية',
    intellectualPropertyDesc: 'جميع الحقوق والعلامات التجارية والمحتوى والتكنولوجيا الخاصة بتطبيق ناوباي مملوكة لشركة ناوباي ، ولا يجوز استخدامها أو نسخها دون إذن كتابي مسبق.',
    amendments: '٩- تعديل الشروط',
    amendmentsDesc: 'يحق لـناوباي تعديل هذه الشروط والأحكام في أي وقت. تصبح التعديلات سارية بمجرد نشرها داخل التطبيق. ويُعد استمرار الاستخدام موافقة على الشروط المعدلة.',
    governingLaw: '١٠ -القانون الواجب التطبيق والاختصاص القضائي',
    governingLawDesc: 'تخضع هذه الشروط والأحكام لقوانين جمهورية مصر العربية، ويتم الفصل في أي نزاع أمام المحاكم المصرية المختصة.',
    consent: '١١- موافقة المستخدم',
    consentDesc: 'باستخدامك لخدمات ناوباي، فإنك تقر بأنك قرأت هذه الشروط وفهمتها ووافقت عليها، وتفوض ناوباي بمعالجة بياناتك بالقدر اللازم لتقديم الخدمات.',
    news: [
      {
        newsDate: "٢٢ يناير ٢٠٢٦",
        newsTitle: "NowPay المصرية تدخل السوق السعودي بشراكة مع تسهيل بقيمة 20 مليون دولار",
        newsDescription: "تطلق شركة NowPay للتقنية المالية المصرية في المملكة العربية السعودية من خلال NowAccess، وهي شركة مشتركة مع تسهيل",
        newsLink: "https://www.wamda.com/2026/01/egypt-nowpay-enters-saudi-market-20m-backed-tasheel-partnership",
        newsImage: "/news/news1.webp",
        media: "Wamda",
      },
      {
        newsDate: "٢٥ يناير ٢٠٢٦",
        newsTitle: "NowPay تدخل السوق السعودي بشراكة تسهيل بقيمة 20 مليون دولار",
        newsDescription: "تطلق شركة NowPay المصرية للتقنية المالية NowAccess في المملكة العربية السعودية من خلال مشروع مشترك بقيمة 20 مليون دولار مع تسهيل",
        newsLink: "https://cairoscene.com/Business/NowPay-Enters-Saudi-Market-With-20M-Tas-heel-Partnership",
        newsImage: "/news/news2.webp",
        media: "Cairo Scene",
      },
      {
        newsDate: "٢٣ يناير ٢٠٢٦",
        newsTitle: "NowPay تدخل السوق السعودي",
        newsDescription: "دخلت شركة NowPay المصرية للتقنية المالية السوق السعودي من خلال إطلاق NowAccess، وهو مشروع مشترك مع تسهيل، الذراع التمويلي الاستهلاكي",
        newsLink: "https://www.islamicfinancenews.com/nowpay-enters-saudi-market.html",
        newsImage: "/news/news3.svg",
        media: "Islamic Finance News",
      },
      {
        newsDate: "٢٢ يناير ٢٠٢٦",
        newsTitle: "NowPay تحصل على 20 مليون دولار للتوسع في المملكة العربية السعودية",
        newsDescription: "ستطلق شركة التكنولوجيا المالية منصتها للرواتب والعافية المالية من خلال مشروع مشترك جديد",
        newsLink: "https://www.startupresearcher.com/news/nowpay-secures-usd20-million-to-expand-into-saudi-arabia",
        newsImage: "/news/news4.svg",
        media: "Startup Researcher",
      },
      {
        newsDate: "٢٢ يناير ٢٠٢٦",
        newsTitle: "NowPay المصرية تجمع 20 مليون دولار لتوسيع خدمات الرواتب المتوافقة مع الشريعة في السعودية",
        newsDescription: "بدلاً من التعامل مع اللوائح السعودية بمفردها، تتخذ NowPay المسار الأسرع من خلال مشروع مشترك بقيمة 20 مليون دولار مع تسهيل",
        newsLink: "https://arabfounders.net/en/nowpay-enters-saudi-arabia-nowaccess-tasheel-20m-jv/",
        newsImage: "/news/news5.webp",
        media: "Arab Founders",
      },
      {
        newsDate: "٢٤ يناير ٢٠٢٦",
        newsTitle: "NowPay المصرية تجمع 20 مليون دولار لنقل منصة الرواتب والأجور المكتسبة إلى السعودية",
        newsDescription: "تواصل NowPay توسعها الإقليمي مع دخولها السوق السعودي من خلال مشروع مشترك مع تسهيل",
        newsLink: "https://techbuild.africa/egyptian-fintech-nowpay-20m-payroll-earned-wage/",
        newsImage: "/news/news6.svg",
        media: "TechBuild Africa",
      },
      {
        newsDate: "١٩ يونيو ٢٠٢٥",
        newsTitle: "تسهيل وNowPay تطلقان 'Now Access' لرقمنة معالجة الأجور في السعودية",
        newsDescription: "أعلنت تسهيل وNowPay عن إطلاق Now Access لتحويل معالجة الأجور رقمياً في المملكة العربية السعودية",
        newsLink: "https://wasssl.com/tasheel-and-nowpay-launch-now-access-to-digitize-wage-processing-in-saudi-arabia/",
        newsImage: "/news/news7.webp",
        media: "Wasssl",
      },
      {
        newsDate: "٢٢ يناير ٢٠٢٦",
        newsTitle: "NowPay المصرية تحصل على 20 مليون دولار لإطلاق مشروع مشترك في السعودية",
        newsDescription: "تحصل NowPay المصرية على 20 مليون دولار لإطلاق مشروعها المشترك في المملكة العربية السعودية",
        newsLink: "https://launchbaseafrica.com/2026/01/22/egypts-nowpay-lands-20m-to-launch-saudi-joint-venture/",
        newsImage: "/news/news8.svg",
        media: "LaunchBase Africa",
      },
    ],
    readArticle: "اقرأ المقال",
    visitSaudiSite: "موقع السعودية",
    formConsent: "أُقرّ بأنني قرأت وفهمت نموذج الموافقة على الخدمة، وأوافق على جمع بياناتي الشخصية واستخدامها والإفصاح عنها وفقًا لما هو موضح فيه."
  },
};

export function getTranslation(lang: Language) {
  return translations[lang];
}
